import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ExportConfigService } from '../data';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable()
export class TemplateService {

    constructor(private exportConfigService: ExportConfigService, private translateService: TranslateService) {
    }

    buildTaskTemplate(activeTaskNode: any, task: any, recommendations: any) {

        return new Promise(resolve => {

            this.exportConfigService.getTaskTemplate().subscribe((resTask) => {

                this.exportConfigService.getAdittionalProposalTemplate().subscribe(resAP => {

                    this.exportConfigService.getFactObservedTemplate().subscribe(resFO => {

                        this.exportConfigService.getRecommendationTemplate().subscribe(resRec => {

                            let html: string = resTask;

                            html = _.replace(html, '$TASK_NAME', activeTaskNode.title);
                            html = _.replace(html, '{lastUser.fullName}', task.lastUser.fullName);
                            html = _.replace(html, '{dateInsert}', task.dateInsert);
                            const isImportantLiteral: string = activeTaskNode.isImportant ? this.translateService.instant('TASK.PRIORITY.HIGH') : this.translateService.instant('TASK.PRIORITY.LOW');
                            html = _.replace(html, '$IS_IMPORTANT', isImportantLiteral);
                            html = _.replace(html, '{typeStateNode.txtState}', task.typeStateNode ? task.typeStateNode.txtState : '');
                            html = _.replace(html, '{txtoDescription}', (task.txtoDescription ? task.txtoDescription : ""));
                            const titleFO = this.translateService.instant('TASK.FACTOBSERVER.LABEL');
                            html = _.replace(html, '[TASK.FACTOBSERVER.LABEL]', titleFO);

                            const titleAP = this.translateService.instant('TASK.ADDITIONALPROPOSAL.LABEL');
                            html = _.replace(html, '[TASK.ADDITIONALPROPOSAL.LABEL]', titleAP);

                            const titleJobDone = this.translateService.instant('WORKS.DONE');
                            html = _.replace(html, '[WORKS.DONE]', titleJobDone);
                            html = _.replace(html, '{txtoJob}', task.txtoJob);


                            let allFO = "";
                            let allAP = "";

                            if (!_.isUndefined(task.factObserver) && !_.isEmpty(task.factObserver)) {

                                const recoIds = _.flatten(_.map(task.factObserver, (item: any)  => {
                                    const ids = _.map(item.recommendation, (reco: any) => reco.idtSqn);
                                    return ids;
                                }));

                                if (!_.isUndefined(recoIds) && !_.isEmpty(recoIds)) {



                                    _.forEach(task.factObserver, (item) => {

                                        item.recommendation = _.filter(recommendations, (it: any) => it.factObserver === item.idFactObserverPk);

                                        allFO += this.buildFactObservedItemTemplate(resFO, resRec, item);
                                    })

                                    html = _.replace(html, '$ALL_FO', allFO);



                                } else {

                                    _.forEach(task.factObserver, (item) => {
                                        allFO += this.buildFactObservedItemTemplate(resFO, resRec, item);
                                    })

                                    html = _.replace(html, '$ALL_FO', allFO);

                                }

                            } else {
                                html = _.replace(html, '$ALL_FO', '');
                            }


                            if (!_.isUndefined(task.additionalProposal) && !_.isEmpty(task.additionalProposal)) {

                                _.forEach(task.additionalProposal, (item) => {

                                    allAP += this.buildAdditionalProposalItemTemplate(resAP, item);
                                })

                                html = _.replace(html, '$ALL_AP', allAP);

                            } else {
                                html = _.replace(html, '$ALL_AP', '');
                            }

                            resolve(html);

                        });

                    })

                });

            })

        })

    }

    buildFactObservedItemTemplate(htmlFactObserved: any, htmlRecommendation: any, factObserver: any) {

        htmlFactObserved = _.replace(htmlFactObserved, '{name}', factObserver.name);
        htmlFactObserved = _.replace(htmlFactObserved, '{description}', factObserver.description);

        const titleRecommendations = this.translateService.instant('TASK.RECOMMENDATION.LABEL');
        htmlFactObserved = _.replace(htmlFactObserved, '[TASK.RECOMMENDATION.LABEL]', titleRecommendations);

        let allReco = '';

        _.forEach(factObserver.recommendation, (item) => {
            allReco += this.buildRecommendationItemTemplate(htmlRecommendation, item);
        });

        htmlFactObserved = _.replace(htmlFactObserved, '$ALL_RECOMMENDATIONS', allReco);


        return htmlFactObserved;

    }

    buildRecommendationItemTemplate(htmlRecommendation: any, recommendation: any) {

        htmlRecommendation = _.replace(htmlRecommendation, '{name}', recommendation.name);

        htmlRecommendation = _.replace(htmlRecommendation, '{department.txtDepartment}', recommendation.department ? recommendation.department.txtDepartment : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{text}', recommendation.text ? recommendation.text : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{typeCritique.txtTypeCritiqueFact}', recommendation.typeCritique ? recommendation.typeCritique.txtTypeCritiqueFact : '');

        let tags: any[] = [];

        if (recommendation.entities) {
            tags = _.map(tags, (item) => { return item.tag });
        }

        const tagsTemplate = this.buildTagsTemplate(tags);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_TAGS', tagsTemplate);

        const risksTemplate = this.buildRisksTemplate(recommendation.risks);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_RISKS', risksTemplate);

        let entities: any[] = [];

        if (recommendation.entities) {
            entities = _.map(entities, (item) => { return item.entity });
        }

        const entitiesTemplate = this.buildEntitiesTemplate(entities);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_ENTITIES', entitiesTemplate);

        htmlRecommendation = _.replace(htmlRecommendation, '{associatedRecommendationName}', recommendation.associatedRecommendationName ? recommendation.associatedRecommendationName : '');

        const processesTemplate = this.buildProcessesTemplate(recommendation.processes);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_PROCESSES', processesTemplate);

        htmlRecommendation = _.replace(htmlRecommendation, '{status}', recommendation.status ? recommendation.status.txtTypeStatusRecommendation : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.userResponsible.cdNuuma}', (recommendation.actionPlan && recommendation.actionPlan.userResponsible) ? recommendation.actionPlan.userResponsible.cdNuuma : '');

        if (recommendation.actionPlan && recommendation.actionPlan.responsible) {

            const trackingResponsible: any = _.filter(recommendation.actionPlan.responsible, (item: any)  => { return item.typeResponsability.txtState === 'RESPONSABILIDAD_DE_SEGUIMIENTO' });

            htmlRecommendation = _.replace(htmlRecommendation, '{tracking-responsible}', (_.get(trackingResponsible, '[0].user')) ? trackingResponsible[0].user.cdNuuma : '');

            const executionResponsible: any = _.filter(recommendation.actionPlan.responsible, (item: any) => { return item.typeResponsability.txtState === 'RESPONSABILIDAD_DE_EJECUCION' });

            if (executionResponsible) {
                htmlRecommendation = _.replace(htmlRecommendation, '{execution-responsible}', (_.get(executionResponsible, '[0].user')) ? executionResponsible[0].user.cdNuuma : '');
            }

        } else {

            htmlRecommendation = _.replace(htmlRecommendation, '{tracking-responsible}', '');
            htmlRecommendation = _.replace(htmlRecommendation, '{execution-responsible}', '');
        }

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.executionDate}', recommendation.actionPlan ? recommendation.actionPlan.executionDate : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.expirationDate}', recommendation.actionPlan ? recommendation.actionPlan.expirationDate : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.progressDegree}', recommendation.actionPlan ? recommendation.actionPlan.progressDegree : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.text}', recommendation.actionPlan ? recommendation.actionPlan.text : '');


        const commentsTemplate = this.buildCommentsTemplate(recommendation.comments);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_COMMENTS', commentsTemplate);

        const translations = _.words(htmlRecommendation, /\[.*?\]/g);

        _.forEach(translations, item => {

            const aux = _.replace(item, /\[+(.*?)\]+/g, '$1');

            const translation = this.translateService.instant(aux);

            htmlRecommendation = _.replace(htmlRecommendation, item, translation);

        })

        return htmlRecommendation;

    }

    buildTagsTemplate(tags: any) {

        let template = '';

        if (tags) {

            _.forEach(tags, (item) => {
                template += '<div class=""><span class="cursor-pointer">' + item.txtName + '</span></div>';
            })
        }

        return template;

    }

    buildRisksTemplate(risks: any) {

        let template = '';

        if (risks) {

            _.forEach(risks, (item) => {
                template += '<div class=""><span class="cursor-pointer">' + item.riskType.description + '</span></div>';
            })
        }

        return template;

    }

    buildEntitiesTemplate(entities: any) {

        let template = '';

        if (entities) {

            _.forEach(entities, (item) => {
                template += '<div class=""><span class="cursor-pointer">' + item.txtName + '</span></div>';
            })
        }

        return template;

    }


    buildProcessesTemplate(processes: any) {

        let template = '';

        if (processes) {

            _.forEach(processes, (item) => {

                const sector = !_.isUndefined(item.sectors) ? item.sectors[0] : item.sector;
                template += '<div class=""><span class="cursor-pointer"> [' + item.processUnitBusiness.unitBusiness.txtoUnitBusiness + ' - ' + item.country.txtName + '] [' + item.processUnitBusiness.txtName + ' - ' + sector.txtNombre + ']</span></div>';
            })
        }

        return template;
    }


    buildCommentsTemplate(comments: any) {

        let template = '';

        if (comments) {

            _.forEach(comments, (item) => {
                template += '<div class=""><span class="cursor-pointer"> [' + item.dateInsert + ' - ' + item.userInsert + '] : ' + item.text + '</span></div>';
            })
        }

        return template;
    }


    buildAdditionalProposalItemTemplate(htmlAdditionalProposal: any, additionalProposal: any) {

        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '{name}', additionalProposal.name);
        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '{description}', additionalProposal.description);

        const entitiesTemplate = this.buildEntitiesTemplate(additionalProposal.entities);

        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '$ALL_ENTITIES', entitiesTemplate);

        const tagsTemplate = this.buildTagsTemplate(additionalProposal.tags);

        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '$ALL_TAGS', tagsTemplate);

        const translations = _.words(htmlAdditionalProposal, /\[.*?\]/g);

        _.forEach(translations, item => {

            const aux = _.replace(item, /\[+(.*?)\]+/g, '$1');

            const translation = this.translateService.instant(aux);

            htmlAdditionalProposal = _.replace(htmlAdditionalProposal, item, translation);

        })

        return htmlAdditionalProposal;

    }


    buildFactObservedTemplate(factObserver: any) {

        return new Promise(resolve => {

            this.exportConfigService.getFactObservedTemplate().subscribe(resFO => {

                this.exportConfigService.getRecommendationTemplate().subscribe(resRec => {

                    const html = this.buildFactObservedItemTemplate(resFO, resRec, factObserver);

                    resolve(html);

                })

            })

        })

    }


    buildRecommendationTemplate(recommendation: any) {

        return new Promise(resolve => {

            this.exportConfigService.getRecommendationTemplate().subscribe(resRec => {

                const html = this.buildRecommendationItemTemplate(resRec, recommendation);

                resolve(html);

            })

        })

    }


    buildAdditionalProposalTemplate(additionalProposal: any) {

        return new Promise(resolve => {

            this.exportConfigService.getAdittionalProposalTemplate().subscribe(resAP => {

                const html = this.buildAdditionalProposalItemTemplate(resAP, additionalProposal);

                resolve(html);

            })

        })

    }

}